"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcExpansionPanelBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var expansion_panel_constants_1 = require("./expansion-panel-constants");
var expansion_panel_constants_2 = require("./expansion-panel-constants");
var expansion_panel_constants_3 = require("./expansion-panel-constants");
var expansion_panel_constants_4 = require("./expansion-panel-constants");
var expansion_panel_constants_5 = require("./expansion-panel-constants");
var expansion_panel_constants_6 = require("./expansion-panel-constants");
var expansion_panel_constants_7 = require("./expansion-panel-constants");
var expansion_panel_constants_8 = require("./expansion-panel-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var BcExpansionPanelBehavior = (function (_super) {
    __extends(BcExpansionPanelBehavior, _super);
    function BcExpansionPanelBehavior() {
        var _this = _super.call(this) || this;
        _this.bcCallBacksEvents = {
            expanded: null,
            contracted: null
        };
        return _this;
    }
    BcExpansionPanelBehavior.setUpAll = function () {
        var expansionPanelElements = Array.from(document.querySelectorAll("div[class~='".concat(expansion_panel_constants_5.BC_EXPANSION_PANEL_SELECTOR, "']")));
        var elements = [];
        for (var _i = 0, expansionPanelElements_1 = expansionPanelElements; _i < expansionPanelElements_1.length; _i++) {
            var element = expansionPanelElements_1[_i];
            var bcExpansionPanelBehavior = new BcExpansionPanelBehavior();
            bcExpansionPanelBehavior.setElement(element);
            bcExpansionPanelBehavior.setUp();
            elements.push(bcExpansionPanelBehavior);
        }
        return elements;
    };
    BcExpansionPanelBehavior.prototype._setUp = function () {
        this.selectElements();
        this.addListeners();
        this.setDefaultValues();
    };
    BcExpansionPanelBehavior.prototype.selectElements = function () {
        this.bcExpansionPanelHeaderElement = this.mySelf.querySelector(".".concat(expansion_panel_constants_6.BC_EXPANSION_PANEL_HEADER_SELECTOR));
        this.bcExpansionPanelContentElement = this.mySelf.querySelector("div[class~='".concat(expansion_panel_constants_7.BC_EXPANSION_PANEL_CONTENT_SELECTOR, "']"));
        this.bcExpansionPanelContentWrapperElement = this.mySelf.querySelector("div[class~='".concat(expansion_panel_constants_7.BC_EXPANSION_PANEL_CONTENT_SELECTOR, "'] .").concat(expansion_panel_constants_1.BC_EXPANSION_PANEL_CONTENT_WRAPPER_SELECTOR));
        this.bcExpansionPanelFooterElement = this.mySelf.querySelector("div[class~='".concat(expansion_panel_constants_8.BC_EXPANSION_PANEL_FOOTER_SELECTOR, "']"));
        this.bcExpansionPanelFooterIconElement = this.bcExpansionPanelFooterElement.querySelector("em[class~='".concat(expansion_panel_constants_4.BC_EXPANSION_PANEL_FOOTER_ICON_SELECTOR, "']"));
    };
    BcExpansionPanelBehavior.prototype.setDefaultValues = function () {
        var idContentElement = "".concat(expansion_panel_constants_7.BC_EXPANSION_PANEL_CONTENT_SELECTOR, "-").concat(this.mySelf.getAttribute('id'));
        this.bcExpansionPanelContentElement.setAttribute('id', idContentElement);
        (0, helpers_1.changeAriaControlsValue)(this.bcExpansionPanelFooterIconElement, idContentElement);
    };
    BcExpansionPanelBehavior.prototype.addListeners = function () {
        this.bcExpansionPanelFooterElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.toogleExpandedContent.bind(this));
    };
    BcExpansionPanelBehavior.prototype.toogleExpandedContent = function () {
        if (this.bcExpansionPanelContentElement.classList.contains("".concat(expansion_panel_constants_5.BC_EXPANSION_PANEL_SELECTOR, "-content-expanded"))) {
            return this.contractContent();
        }
        return this.expandContent();
    };
    BcExpansionPanelBehavior.prototype.contractContent = function () {
        this.bcExpansionPanelContentElement.classList.remove("".concat(expansion_panel_constants_5.BC_EXPANSION_PANEL_SELECTOR, "-content-expanded"));
        this.bcExpansionPanelContentWrapperElement.style.opacity = '0';
        this.bcExpansionPanelFooterIconElement.innerHTML = expansion_panel_constants_2.BC_EXPANSION_ICON_DOWN;
        (0, helpers_1.changeAriaExpandedValue)(this.bcExpansionPanelContentElement, false);
        return this.bcCallBacksEvents.contracted ? this.bcCallBacksEvents.contracted() : undefined;
    };
    BcExpansionPanelBehavior.prototype.expandContent = function () {
        this.bcExpansionPanelContentElement.classList.add("".concat(expansion_panel_constants_5.BC_EXPANSION_PANEL_SELECTOR, "-content-expanded"));
        this.bcExpansionPanelFooterIconElement.innerHTML = expansion_panel_constants_3.BC_EXPANSION_ICON_UP;
        this.bcExpansionPanelContentWrapperElement.style.opacity = '1';
        (0, helpers_1.changeAriaExpandedValue)(this.bcExpansionPanelContentElement, true);
        return this.bcCallBacksEvents.expanded ? this.bcCallBacksEvents.expanded() : undefined;
    };
    BcExpansionPanelBehavior.prototype.on = function (eventText, callback) {
        this.bcCallBacksEvents[eventText] = callback;
    };
    return BcExpansionPanelBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcExpansionPanelBehavior = BcExpansionPanelBehavior;
